import { errorManagerInstance } from '@app/engine/utils/errorManager';
import { t7e } from '@app/locales/keys';
import 'flag-icons/css/flag-icons.min.css';
import '../../../../public/css/flag-icons.css';
export const countryCodeList = {
    'Afghanistan': 'AF',
    'Algeria': 'ALG',
    'Argentina': 'AR|ARGN',
    'Australia': 'AU|AUS',
    'Austria': 'AT|ASRA',
    'Azerbaijan': 'AZ|AZER',
    'Bahrain': 'BH',
    'Belarus': 'BY|BELA',
    'Belgium': 'B|BEL',
    'Bolivia': 'BOL',
    'Botswana': 'BW|BOTS',
    'Brazil': 'BR|BRAZ',
    'Canada': 'CA',
    'Chile': 'CHLE',
    'China': 'CN|PRC',
    'Colombia': 'CO|COL',
    'Czechoslovakia': 'CZ|CZCH',
    'Denmark': 'DK|DEN',
    'Egypt': 'EG|EGYP',
    'Estonia': 'EE|EST',
    'European Space Agency': 'ESA|I-ESA',
    'ESA and JAXA': 'ESA/JAXA',
    'Finland': 'FI|FIN',
    'France': 'F|FR|France',
    'Germany': 'D|GER',
    'Globalstar': 'GLOB|ORB',
    'Greece': 'GR|GREC',
    'Hong Kong': 'HK',
    'Hungary': 'HU|HUN',
    'India': 'IN|IND',
    'Indonesia': 'ID|INDO',
    'Inmarsat': 'IM',
    'International': 'ISS',
    'Intelsat': 'ITSO',
    'Iran': 'IR|IRAN',
    'Iraq': 'IQ|IRAQ',
    'Ireland': 'IE',
    'Israel': 'IL|ISRA',
    'Italy': 'I|IT',
    'Japan': 'J|Japan|JP|JPN',
    'Jordan': 'JOR',
    'Kazakhstan': 'KZ|KAZ',
    'Kuwait': 'KWT',
    'Laos': 'LAOS',
    'Lithuania': 'LTU',
    'Luxembourg': 'LUXE',
    'Malaysia': 'MALA',
    'Mauritius': 'MUS',
    'Mexico': 'MX|MEX',
    'Moldova': 'MDA',
    'Mongolia': 'MNG',
    'Morocco': 'MA',
    'NATO': 'NATO',
    'Netherlands': 'NL|NETH',
    'New Zealand': 'NZ|NZL|New Zealand',
    'Nigeria': 'NG|NIG',
    'North Korea': 'KP|NKOR',
    'Norway': 'N|NO|NOR',
    'O3B': 'O3B',
    'Peru': 'PE|PERU',
    'Philippines': 'PH|RP',
    'Poland': 'PL|POL',
    'Portugal': 'PT|POR',
    'Russia': 'RU|SU|CIS|Russia',
    'Saudi Arabia': 'SA|SAUD',
    'Singapore': 'SG|SING',
    'South Africa': 'ZA',
    'South Korea': 'KR|SKOR',
    'Spain': 'E|Spain|ES|SPN',
    'Sweden': 'S|SWED',
    'Switzerland': 'CH|SWTZ',
    'Thailand': 'T|THAI',
    'Turkey': 'TR|TURK',
    'Ukraine': 'UKR',
    'United Arab Emirates': 'AE|UAE',
    'United Kingdom': 'UK',
    'United States': 'US|USA|United States',
    'Uruguay': 'UY|URY',
    'Venezuela': 'VE|VENZ',
    'Vietnam': 'VN|VTNM',
};
export const countryFlagIconMap = {
    'AAT': 'AAT', // No matching code, kept original
    'ADG': 'RU', // Adygea is part of Russia
    'AF': 'AF',
    'AG': 'AG',
    'AGUK': 'AG',
    'AM': 'AM',
    'ANTN': 'ANTN', // No matching code, kept original
    'AO': 'AO',
    'AQ': 'AQ', // Added new code for Antarctica
    'AR': 'AR',
    'ARV': 'AR', // Argentine Antarctic is part of Argentina
    'AT': 'AT',
    'AU': 'AU',
    'AZ': 'AZ',
    'B': 'BE', // Belgium
    'BASH': 'RU', // Bashkiria is part of Russia
    'BAT': 'BAT', // No matching code, kept original
    'BB': 'BB',
    'BBUK': 'BB',
    'BD': 'BD',
    'BG': 'BG',
    'BGN': 'BG', // PR Bulgaria is now Bulgaria
    'BH': 'BH',
    'BM': 'BM',
    'BO': 'BO',
    'BR': 'BR',
    'BS': 'BS',
    'BT': 'BT',
    'BY': 'BY',
    'CA': 'CA',
    'CD': 'CD',
    'CH': 'CH',
    'CI': 'CI',
    'CK': 'CK',
    'CL': 'CL',
    'CM': 'CM',
    'CN': 'CN',
    'CO': 'CO',
    'COLP': 'CG', // Congo
    'CR': 'CR',
    'CSFR': 'CSFR', // No matching code, kept original (historical Czechoslovakia)
    'CSSR': 'CSSR', // No matching code, kept original (historical Czechoslovakia)
    'CU': 'CU',
    'CYM': 'KY', // Cayman Islands
    'CYMRU': 'GB-WLS', // Wales
    'CZ': 'CZ',
    'D': 'DE', // Germany
    'DAG': 'RU', // Dagestan is part of Russia
    'DD': 'DD', // No matching code, kept original (historical East Germany)
    'DK': 'DK',
    'DML': 'DML', // No matching code, kept original
    'DR': 'DR', // No matching code, kept original (historical Germany)
    'DX': 'DX', // No matching code, kept original (historical occupied Germany)
    'DZ': 'DZ',
    'E': 'ES', // Spain
    'ES': 'ES',
    'Spain': 'ES',
    'EC': 'EC',
    'EE': 'EE',
    'EG': 'EG',
    'ENG': 'GB-ENG', // England
    'ESCN': 'ES', // Canary Islands are part of Spain
    'ET': 'ET',
    'F': 'FR', // France
    'FI': 'FI',
    'GE': 'GE',
    'GH': 'GH',
    'GI': 'GI',
    'GL': 'GL',
    'GR': 'GR',
    '': 'GD', // Grenada (fixed empty key)
    'GT': 'GT',
    'GU': 'GU',
    'GUF': 'GF', // French Guiana
    'HK': 'HK',
    'HKUK': 'HK',
    'HU': 'HU',
    'I': 'IT', // Italy
    'I-ARAB': 'I-ARAB', // No matching code, kept original
    'I-CSC1': 'I-CSC1', // No matching code, kept original
    'I-ELDO': 'I-ELDO', // No matching code, kept original
    'I-ESRO': 'I-ESRO', // No matching code, kept original
    'I-EUM': 'I-EUM', // No matching code, kept original
    'I-EU': 'I-EU', // No matching code, kept original
    'I-EUT': 'I-EUT', // No matching code, kept original
    'I-INM': 'I-INM', // No matching code, kept original
    'I-INT': 'I-INT', // No matching code, kept original
    'I-ISS': 'I-ISS', // No matching code, kept original
    'I-NATO': 'I-NATO', // No matching code, kept original
    'I-RASC': 'I-RASC', // No matching code, kept original
    'ID': 'ID',
    'IE': 'IE',
    'IL': 'IL',
    'IN': 'IN',
    'IQ': 'IQ',
    'IR': 'IR',
    'IS': 'IS',
    'J': 'JP', // Japan
    'Japan': 'JP', // Japan - TODO: Fixx this in the database
    'JO': 'JO',
    'KE': 'KE',
    'KI': 'KI',
    'KG': 'KG',
    'KGSR': 'KG', // Kyrgyz SSR is now Kyrgyzstan
    'KH': 'KH',
    'KORS': 'KORS', // No matching code, kept original
    'KORSA': 'KORSA', // No matching code, kept original
    'KP': 'KP',
    'KR': 'KR',
    'KW': 'KW',
    'KZ': 'KZ',
    'L': 'LU', // Luxembourg
    'LA': 'LA',
    'LB': 'LB',
    'LK': 'LK',
    'LT': 'LT',
    'LV': 'LV',
    'LY': 'LY',
    'MA': 'MA',
    'MC': 'MC',
    'MD': 'MD',
    'MH': 'MH',
    'MN': 'MN',
    'MR': 'MR',
    'MU': 'MU',
    'MV': 'MV',
    'MX': 'MX',
    'MY': 'MY',
    'MYM': 'MM', // Myanmar
    'N': 'NO', // Norway
    'NO': 'NO', // Norway
    'NG': 'NG',
    'NL': 'NL',
    'NP': 'NP',
    'NZ': 'NZ',
    'NZRD': 'NZRD', // No matching code, kept original
    'P': 'PT', // Portugal
    'PAR': 'PA', // Panama
    'PCZ': 'PCZ', // No matching code, kept original
    'PE': 'PE',
    'PG': 'PG',
    'PK': 'PK',
    'PH': 'PH',
    'PL': 'PL',
    'PLRL': 'PL',
    'PR': 'PR',
    'PT': 'PT',
    'PY': 'PY',
    'QA': 'QA',
    'RO': 'RO',
    'RU': 'RU',
    'RW': 'RW',
    'S': 'SE', // Sweden
    'SA': 'SA',
    'SCOT': 'GB-SCT', // Scotland
    'SD': 'SD',
    'SG': 'SG',
    'SH': 'SH',
    'SI': 'SI',
    'SK': 'SK',
    'SR': 'SR',
    'SU': 'SU', // No matching code, kept original (historical USSR)
    'SY': 'SY',
    'T': 'TH', // Thailand
    'TC': 'TC',
    'TF': 'TF',
    'TJ': 'TJ',
    'TM': 'TM',
    'TN': 'TN',
    'TO': 'TO',
    'TR': 'TR',
    'TTPI': 'TTPI', // No matching code, kept original
    'TUVA': 'RU', // Tuva is part of Russia
    'TW': 'TW',
    'UA': 'UA',
    'UAE': 'AE', // United Arab Emirates
    'UK': 'GB', // United Kingdom
    'UM': 'UM',
    'US': 'US',
    'UY': 'UY',
    'UZ': 'UZ',
    'VE': 'VE',
    'VN': 'VN',
    'YE': 'YE',
    'ZA': 'ZA',
    'ZR': 'CD', // Zaire is now Democratic Republic of the Congo
    'ANALSAT': 'ANALSAT', // No matching code, kept original
    'SAUD': 'SA', // Saudi Arabia
    'AB': 'SA', // Saudi Arabia
    'AC': 'AC', // No matching code, kept original
    'ALG': 'DZ', // Algeria
    'ALL': 'ALL', // No matching code, kept original
    'ARGN': 'AR', // Argentina
    'ASRA': 'AT', // Austria
    'AUS': 'AU',
    'AZER': 'AZ',
    'BEL': 'BE',
    'BELA': 'BY',
    'BERM': 'BM',
    'BOL': 'BO',
    'BRAZ': 'BR',
    'CHBZ': 'CHBZ', // No matching code, kept original
    'CHLE': 'CL', // Chile
    'CIS': 'CIS', // No matching code, kept original
    'COL': 'CO',
    'CZCH': 'CZ', // Czech Republic (formerly Czechoslovakia)
    'DEN': 'DK',
    'ECU': 'EC',
    'EGYP': 'EG',
    'ESA': 'ESA', // No matching code, kept original
    'ESA/JAXA': 'ESA/JAXA', // No matching code, kept original
    'I-ESA': 'I-ESA', // No matching code, kept original
    'EST': 'EE',
    'EUME': 'EUME', // No matching code, kept original
    'EUTE': 'EUTE', // No matching code, kept original
    'FIN': 'FI',
    'FGER': 'FGER', // No matching code, kept original
    'FR': 'FR',
    'FRIT': 'FRIT', // No matching code, kept original
    'GER': 'DE',
    'GLOB': 'US',
    'GREC': 'GR',
    'HUN': 'HU',
    'IM': 'IM',
    'IND': 'IN',
    'INDO': 'ID',
    'IRAN': 'IR',
    'IRAQ': 'IQ',
    'ISRA': 'IL',
    'ISS': 'ISS', // No matching code, kept original
    'IT': 'IT',
    'ITSO': 'LU', // Luxembourg
    'JPN': 'JP',
    'KAZ': 'KZ',
    'LAOS': 'LA',
    'LTU': 'LT',
    'LUXE': 'LU',
    'MALA': 'MY',
    'MEX': 'MX',
    'NATO': 'NATO', // No matching code, kept original
    'NETH': 'NL',
    'NICO': 'US',
    'NIG': 'NG',
    'NKOR': 'KP',
    'NOR': 'NO',
    'O3B': 'LU',
    'ORB': 'US',
    'PAKI': 'PK',
    'PERU': 'PE',
    'POL': 'PL',
    'POR': 'PT',
    'PRC': 'CN',
    'RASC': 'MU', // Mauritius
    'ROC': 'TW',
    'Taiwan': 'TW',
    'ROM': 'RO',
    'SAFR': 'ZA',
    'SEAL': 'RU',
    'RP': 'PH',
    'SES': 'LU',
    'SING': 'SG',
    'SKOR': 'KR',
    'SPN': 'ES',
    'STCT': 'STCT', // No matching code, kept original
    'SWED': 'SE',
    'SWTZ': 'CH',
    'THAI': 'TH',
    'TMMC': 'TMMC', // No matching code, kept original
    'TURK': 'TR',
    'UKR': 'UA',
    'URY': 'UY',
    'USA': 'US',
    'USBZ': 'USBZ', // No matching code, kept original
    'VENZ': 'VE',
    'VTNM': 'VN',
    'TBD': 'TBD', // No matching code, kept original
};
export const country2flagIcon = (country) => {
    if (!country || country === '') {
        return 'fi-unknown';
    }
    // Get the country code from the list
    const countryCode = countryCodeList[country] ?? countryCodeList[getCountryMapList()[country]] ?? country;
    // Flag codes look like this: fi-us (for United States) or fi-uk (for United Kingdom)
    // If there is more than one then we will use both
    if (countryCode) {
        const codes = countryCode.split('|').map((code) => countryFlagIconMap[code] ?? code.toLowerCase());
        return `fi-${codes[0].toLowerCase()}`;
    }
    errorManagerInstance.debug(`Country code not found for ${country}`);
    return 'fi-unknown';
};
/**
 * An array of country names with satellites.
 */
export const countryNameList = Object.keys(countryCodeList);
export const getCountryMapList = () => ({
    'AAT': t7e('countries.AAT'),
    'ADG': t7e('countries.ADG'),
    'AF': t7e('countries.AF'),
    'AG': t7e('countries.AG'),
    'AGUK': t7e('countries.AGUK'),
    'AM': t7e('countries.AM'),
    'ANTN': t7e('countries.ANTN'),
    'AO': t7e('countries.AO'),
    'AQ': t7e('countries.AQ'),
    'AR': t7e('countries.AR'),
    'ARV': t7e('countries.ARV'),
    'AT': t7e('countries.AT'),
    'AU': t7e('countries.AU'),
    'AZ': t7e('countries.AZ'),
    'B': t7e('countries.B'),
    'BASH': t7e('countries.BASH'),
    'BAT': t7e('countries.BAT'),
    'BB': t7e('countries.BB'),
    'BBUK': t7e('countries.BBUK'),
    'BD': t7e('countries.BD'),
    'BG': t7e('countries.BG'),
    'BGN': t7e('countries.BGN'),
    'BH': t7e('countries.BH'),
    'BM': t7e('countries.BM'),
    'BO': t7e('countries.BO'),
    'BR': t7e('countries.BR'),
    'BS': t7e('countries.BS'),
    'BT': t7e('countries.BT'),
    'BW': t7e('countries.BW'),
    'BY': t7e('countries.BY'),
    'CA': t7e('countries.CA'),
    'CD': t7e('countries.CD'),
    'CH': t7e('countries.CH'),
    'CI': t7e('countries.CI'),
    'CK': t7e('countries.CK'),
    'CL': t7e('countries.CL'),
    'CM': t7e('countries.CM'),
    'CN': t7e('countries.CN'),
    'CO': t7e('countries.CO'),
    'COLP': t7e('countries.COLP'),
    'CR': t7e('countries.CR'),
    'CSFR': t7e('countries.CSFR'),
    'CSSR': t7e('countries.CSSR'),
    'CU': t7e('countries.CU'),
    'CYM': t7e('countries.CYM'),
    'CYMRU': t7e('countries.CYMRU'),
    'CZ': t7e('countries.CZ'),
    'D': t7e('countries.D'),
    'DAG': t7e('countries.DAG'),
    'DD': t7e('countries.DD'),
    'DJ': t7e('countries.DJ'),
    'DK': t7e('countries.DK'),
    'DML': t7e('countries.DML'),
    'DR': t7e('countries.DR'),
    'DX': t7e('countries.DX'),
    'DZ': t7e('countries.DZ'),
    'E': t7e('countries.E'),
    'EC': t7e('countries.EC'),
    'EE': t7e('countries.EE'),
    'EG': t7e('countries.EG'),
    'ENG': t7e('countries.ENG'),
    'ES': t7e('countries.SPN'),
    'ESCN': t7e('countries.ESCN'),
    'ESA/JAXA': t7e('countries.ESA/JAXA'),
    'ET': t7e('countries.ET'),
    'F': t7e('countries.F'),
    'France': t7e('countries.F'),
    'FI': t7e('countries.FI'),
    'GE': t7e('countries.GE'),
    'GH': t7e('countries.GH'),
    'GI': t7e('countries.GI'),
    'GL': t7e('countries.GL'),
    'GR': t7e('countries.GR'),
    'GRD': t7e('countries.GRD'),
    'GT': t7e('countries.GT'),
    'GU': t7e('countries.GU'),
    'GUF': t7e('countries.GUF'),
    'HK': t7e('countries.HK'),
    'HKUK': t7e('countries.HKUK'),
    'HR': t7e('countries.HR'),
    'HU': t7e('countries.HU'),
    'I': t7e('countries.I'),
    'I-ARAB': t7e('countries.I-ARAB'),
    'I-CSC1': t7e('countries.I-CSC1'),
    'I-ELDO': t7e('countries.I-ELDO'),
    'I-ESRO': t7e('countries.I-ESRO'),
    'I-EUM': t7e('countries.I-EUM'),
    'I-EU': t7e('countries.I-EU'),
    'I-EUT': t7e('countries.I-EUT'),
    'I-INM': t7e('countries.I-INM'),
    'I-INT': t7e('countries.I-INT'),
    'I-ISS': t7e('countries.I-ISS'),
    'I-NATO': t7e('countries.I-NATO'),
    'I-RASC': t7e('countries.I-RASC'),
    'ID': t7e('countries.ID'),
    'IE': t7e('countries.IE'),
    'IL': t7e('countries.IL'),
    'IN': t7e('countries.IN'),
    'IQ': t7e('countries.IQ'),
    'IR': t7e('countries.IR'),
    'IS': t7e('countries.IS'),
    'J': t7e('countries.J'),
    'Japan': t7e('countries.J'),
    'JP': t7e('countries.J'),
    'JO': t7e('countries.JO'),
    'KE': t7e('countries.KE'),
    'KI': t7e('countries.KI'),
    'KG': t7e('countries.KG'),
    'KGSR': t7e('countries.KGSR'),
    'KH': t7e('countries.KH'),
    'KORS': t7e('countries.KORS'),
    'KORSA': t7e('countries.KORSA'),
    'KP': t7e('countries.KP'),
    'KR': t7e('countries.KR'),
    'KW': t7e('countries.KW'),
    'KZ': t7e('countries.KZ'),
    'L': t7e('countries.L'),
    'LA': t7e('countries.LA'),
    'LB': t7e('countries.LB'),
    'LK': t7e('countries.LK'),
    'LT': t7e('countries.LT'),
    'LV': t7e('countries.LV'),
    'LY': t7e('countries.LY'),
    'MA': t7e('countries.MA'),
    'MC': t7e('countries.MC'),
    'MD': t7e('countries.MD'),
    'MH': t7e('countries.MH'),
    'MN': t7e('countries.MN'),
    'MR': t7e('countries.MR'),
    'MU': t7e('countries.MU'),
    'MV': t7e('countries.MV'),
    'MX': t7e('countries.MX'),
    'MY': t7e('countries.MY'),
    'MYM': t7e('countries.MYM'),
    'N': t7e('countries.N'),
    'NO': t7e('countries.N'),
    'NG': t7e('countries.NG'),
    'NL': t7e('countries.NL'),
    'NP': t7e('countries.NP'),
    'NZ': t7e('countries.NZ'),
    'New Zealand': t7e('countries.NZ'),
    'NZRD': t7e('countries.NZRD'),
    'OM': t7e('countries.OM'),
    'P': t7e('countries.P'),
    'PAR': t7e('countries.PAR'),
    'PCZ': t7e('countries.PCZ'),
    'PE': t7e('countries.PE'),
    'PG': t7e('countries.PG'),
    'PK': t7e('countries.PK'),
    'PH': t7e('countries.PH'),
    'PL': t7e('countries.PL'),
    'PLRL': t7e('countries.PLRL'),
    'PR': t7e('countries.PR'),
    'PT': t7e('countries.PT'),
    'PY': t7e('countries.PY'),
    'QA': t7e('countries.QA'),
    'RO': t7e('countries.RO'),
    'RU': t7e('countries.RU'),
    'Russia': t7e('countries.RU'),
    'RW': t7e('countries.RW'),
    'S': t7e('countries.S'),
    'SA': t7e('countries.SA'),
    'SCOT': t7e('countries.SCOT'),
    'SD': t7e('countries.SD'),
    'SG': t7e('countries.SG'),
    'SH': t7e('countries.SH'),
    'SI': t7e('countries.SI'),
    'SK': t7e('countries.SK'),
    'SR': t7e('countries.SR'),
    'SU': t7e('countries.SU'),
    'SY': t7e('countries.SY'),
    'T': t7e('countries.T'),
    'TC': t7e('countries.TC'),
    'TF': t7e('countries.TF'),
    'TJ': t7e('countries.TJ'),
    'TM': t7e('countries.TM'),
    'TN': t7e('countries.TN'),
    'TO': t7e('countries.TO'),
    'TR': t7e('countries.TR'),
    'TTPI': t7e('countries.TTPI'),
    'TUVA': t7e('countries.TUVA'),
    'TW': t7e('countries.TW'),
    'UA': t7e('countries.UA'),
    'UAE': t7e('countries.UAE'),
    'UK': t7e('countries.UK'),
    'UM': t7e('countries.UM'),
    'US': t7e('countries.US'),
    'United States': t7e('countries.US'),
    'UY': t7e('countries.UY'),
    'UZ': t7e('countries.UZ'),
    'VE': t7e('countries.VE'),
    'VN': t7e('countries.VN'),
    'YE': t7e('countries.YE'),
    'ZA': t7e('countries.ZA'),
    'ZR': t7e('countries.ZR'),
    'ZW': t7e('countries.ZW'),
    'ANALSAT': t7e('countries.ANALSAT'),
    'SAUD': t7e('countries.SAUD'),
    'AB': t7e('countries.AB'),
    'AC': t7e('countries.AC'),
    'ALG': t7e('countries.ALG'),
    'ALL': t7e('countries.ALL'),
    'ARGN': t7e('countries.ARGN'),
    'ASRA': t7e('countries.ASRA'),
    'AUS': t7e('countries.AUS'),
    'AZER': t7e('countries.AZER'),
    'BEL': t7e('countries.BEL'),
    'BELA': t7e('countries.BELA'),
    'BERM': t7e('countries.BERM'),
    'BOL': t7e('countries.BOL'),
    'BRAZ': t7e('countries.BRAZ'),
    'CHBZ': t7e('countries.CHBZ'),
    'CHLE': t7e('countries.CHLE'),
    'CIS': t7e('countries.CIS'),
    'COL': t7e('countries.COL'),
    'CZCH': t7e('countries.CZCH'),
    'DEN': t7e('countries.DEN'),
    'ECU': t7e('countries.ECU'),
    'EGYP': t7e('countries.EGYP'),
    'ESA': t7e('countries.ESA'),
    'I-ESA': t7e('countries.I-ESA'),
    'EST': t7e('countries.EST'),
    'EUME': t7e('countries.EUME'),
    'EUTE': t7e('countries.EUTE'),
    'FIN': t7e('countries.FIN'),
    'FGER': t7e('countries.FGER'),
    'FR': t7e('countries.FR'),
    'FRIT': t7e('countries.FRIT'),
    'GER': t7e('countries.GER'),
    'GLOB': t7e('countries.GLOB'),
    'GREC': t7e('countries.GREC'),
    'HUN': t7e('countries.HUN'),
    'IM': t7e('countries.IM'),
    'IND': t7e('countries.IND'),
    'INDO': t7e('countries.INDO'),
    'IRAN': t7e('countries.IRAN'),
    'IRAQ': t7e('countries.IRAQ'),
    'ISRA': t7e('countries.ISRA'),
    'ISS': t7e('countries.ISS'),
    'IT': t7e('countries.IT'),
    'ITSO': t7e('countries.ITSO'),
    'JPN': t7e('countries.JPN'),
    'KAZ': t7e('countries.KAZ'),
    'LAOS': t7e('countries.LAOS'),
    'LTU': t7e('countries.LTU'),
    'LUXE': t7e('countries.LUXE'),
    'MALA': t7e('countries.MALA'),
    'MEX': t7e('countries.MEX'),
    'NATO': t7e('countries.NATO'),
    'NETH': t7e('countries.NETH'),
    'NICO': t7e('countries.NICO'),
    'NIG': t7e('countries.NIG'),
    'NKOR': t7e('countries.NKOR'),
    'NOR': t7e('countries.NOR'),
    'O3B': t7e('countries.O3B'),
    'ORB': t7e('countries.ORB'),
    'PAKI': t7e('countries.PAKI'),
    'PERU': t7e('countries.PERU'),
    'POL': t7e('countries.POL'),
    'POR': t7e('countries.POR'),
    'PRC': t7e('countries.PRC'),
    'RASC': t7e('countries.RASC'),
    'ROC': t7e('countries.ROC'),
    'Taiwan': t7e('countries.Taiwan'),
    'ROM': t7e('countries.ROM'),
    'SAFR': t7e('countries.SAFR'),
    'SEAL': t7e('countries.SEAL'),
    'RP': t7e('countries.RP'),
    'SES': t7e('countries.SES'),
    'SING': t7e('countries.SING'),
    'SKOR': t7e('countries.SKOR'),
    'SN': t7e('countries.SN'),
    'SPN': t7e('countries.SPN'),
    'Spain': t7e('countries.SPN'),
    'STCT': t7e('countries.STCT'),
    'SWED': t7e('countries.SWED'),
    'SWTZ': t7e('countries.SWTZ'),
    'THAI': t7e('countries.THAI'),
    'TMMC': t7e('countries.TMMC'),
    'TURK': t7e('countries.TURK'),
    'UKR': t7e('countries.UKR'),
    'URY': t7e('countries.URY'),
    'USA': t7e('countries.USA'),
    'USBZ': t7e('countries.USBZ'),
    'VENZ': t7e('countries.VENZ'),
    'VTNM': t7e('countries.VTNM'),
    'TBD': t7e('countries.TBD'),
});
export const launchSiteMap = {
    ANALSAT: {
        site: 'Analyst Satellite',
        country: 'Analyst Satellite',
        wikiUrl: null, // No specific Wikipedia page found
    },
    AFETR: {
        site: 'Cape Canaveral SFS',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Cape_Canaveral_Space_Force_Station',
    },
    AFWTR: {
        site: 'Vandenberg SFB',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Vandenberg_Space_Force_Base',
    },
    CAS: {
        site: 'Canaries Airspace',
        country: 'United States',
        wikiUrl: null, // No specific Wikipedia page found
    },
    FRGUI: {
        site: 'Kourou',
        country: 'French Guiana',
        wikiUrl: 'https://en.wikipedia.org/wiki/Guiana_Space_Centre',
    },
    HGSTR: {
        site: 'Hammaguira STR',
        country: 'Algeria',
        wikiUrl: 'https://en.wikipedia.org/wiki/Hammaguir',
    },
    KSCUT: {
        site: 'Uchinoura SC',
        country: 'Japan',
        wikiUrl: 'https://en.wikipedia.org/wiki/Uchinoura_Space_Center',
    },
    KYMTR: {
        site: 'Kapustin Yar MSC',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Kapustin_Yar',
    },
    PKMTR: {
        site: 'Plesetsk MSC',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Plesetsk_Cosmodrome',
    },
    WSC: {
        site: 'Wenchang SC',
        country: 'China',
        wikiUrl: 'https://en.wikipedia.org/wiki/Wenchang_Spacecraft_Launch_Site',
    },
    SNMLP: {
        site: 'San Marco LP',
        country: 'Kenya',
        wikiUrl: 'https://en.wikipedia.org/wiki/San_Marco_Platform',
    },
    SRI: {
        site: 'Satish Dhawan SC',
        country: 'India',
        wikiUrl: 'https://en.wikipedia.org/wiki/Satish_Dhawan_Space_Centre',
    },
    TNSTA: {
        site: 'Tanegashima SC',
        country: 'Japan',
        wikiUrl: 'https://en.wikipedia.org/wiki/Tanegashima_Space_Center',
    },
    TTMTR: {
        site: 'Baikonur Cosmodrome',
        country: 'Kazakhstan',
        wikiUrl: 'https://en.wikipedia.org/wiki/Baikonur_Cosmodrome',
    },
    WLPIS: {
        site: 'Wallops Island',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Mid-Atlantic_Regional_Spaceport',
    },
    WOMRA: {
        site: 'Woomera',
        country: 'Australia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Woomera_Test_Range',
    },
    VOSTO: {
        site: 'Vostochny Cosmodrome',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Vostochny_Cosmodrome',
    },
    PMRF: {
        site: 'PMRF Barking Sands',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Pacific_Missile_Range_Facility',
    },
    SEAL: {
        site: 'Sea Launch Platform',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Sea_Launch',
    },
    KWAJ: {
        site: 'Kwajalein Atoll',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Kwajalein_Atoll',
    },
    ERAS: {
        site: 'Eastern Range Airspace',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Eastern_Range',
    },
    JSC: {
        site: 'Jiuquan SC',
        country: 'China',
        wikiUrl: 'https://en.wikipedia.org/wiki/Jiuquan_Satellite_Launch_Center',
    },
    SVOB: {
        site: 'Svobodny LC',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Svobodny_Cosmodrome',
    },
    TSC: {
        site: 'Taiyuan SC',
        country: 'China',
        wikiUrl: 'https://en.wikipedia.org/wiki/Taiyuan_Satellite_Launch_Center',
    },
    WRAS: {
        site: 'Western Range Airspace',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Western_Launch_and_Test_Range',
    },
    XSC: {
        site: 'Xichang SC',
        country: 'China',
        wikiUrl: 'https://en.wikipedia.org/wiki/Xichang_Satellite_Launch_Center',
    },
    XICLF: {
        site: 'Xichang Launch Facility',
        country: 'China',
        wikiUrl: 'https://en.wikipedia.org/wiki/Xichang_Satellite_Launch_Center',
    },
    YAVNE: {
        site: 'Yavne Launch Facility',
        country: 'Israel',
        wikiUrl: 'https://en.wikipedia.org/wiki/Israel_Aerospace_Industries',
    },
    OREN: {
        site: 'Orenburg',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Orenburg',
    },
    SADOL: {
        site: 'Submarine Launch',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Submarine-launched_ballistic_missile',
    },
    KODAK: {
        site: 'Kodiak LC',
        country: 'United States',
        wikiUrl: 'https://en.wikipedia.org/wiki/Pacific_Spaceport_Complex_%E2%80%93_Alaska',
    },
    SEM: {
        site: 'Semnan',
        country: 'Iran',
        wikiUrl: 'https://en.wikipedia.org/wiki/Imam_Khomeini_Spaceport',
    },
    YUN: {
        site: 'Yunsong LS',
        country: 'North Korea',
        wikiUrl: 'https://en.wikipedia.org/wiki/Tonghae_Satellite_Launching_Ground',
    },
    TNGH: {
        site: 'Tonghae SLG',
        country: 'North Korea',
        wikiUrl: 'https://en.wikipedia.org/wiki/Tonghae_Satellite_Launching_Ground',
    },
    NSC: {
        site: 'Naro SC',
        country: 'South Korea',
        wikiUrl: 'https://en.wikipedia.org/wiki/Naro_Space_Center',
    },
    RLLC: {
        site: 'Rocket Lab Launch Complex 1',
        country: 'New Zealand',
        wikiUrl: 'https://en.wikipedia.org/wiki/Rocket_Lab_Launch_Complex_1',
    },
    AMH: {
        site: 'A\' Mhòine',
        country: 'Scotland',
        wikiUrl: 'https://en.wikipedia.org/wiki/Sutherland_Spaceport',
    },
    ALC: {
        site: 'Alcântara Launch Center',
        country: 'Brazil',
        wikiUrl: 'https://en.wikipedia.org/wiki/Alc%C3%A2ntara_Launch_Center',
    },
    TYMSC: {
        site: 'Baikonur Cosmodrome',
        country: 'Kazakhstan',
        wikiUrl: 'https://en.wikipedia.org/wiki/Baikonur_Cosmodrome',
    },
    PLMSC: {
        site: 'Plesetsk Cosmodrome',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Plesetsk_Cosmodrome',
    },
    DLS: {
        site: 'Dombarovsky Launch Site',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Dombarovsky_(air_base)',
    },
    RLLB: {
        site: 'Rocket Lab Launch Complex 2',
        country: 'New Zealand',
        wikiUrl: 'https://en.wikipedia.org/wiki/Rocket_Lab_Launch_Complex_2',
    },
    YSLA: {
        site: 'Yellow Sea Launch Area',
        country: 'China',
        wikiUrl: 'https://en.wikipedia.org/wiki/Sea_Launch',
    },
    SMTS: {
        site: 'Shahrud Missile Test Site',
        country: 'Iran',
        wikiUrl: 'https://en.wikipedia.org/wiki/Shahrud_Missile_Test_Site',
    },
    JJSLA: {
        site: 'Jeju Island Sea Launch Area',
        country: 'South Korea',
        wikiUrl: null, // No specific Wikipedia page found
    },
    SCSLA: {
        site: 'South China Sea Launch Area',
        country: 'China',
        wikiUrl: null, // No specific Wikipedia page found
    },
    SEMLS: {
        site: 'Semnan Space Launch Site',
        country: 'Iran',
        wikiUrl: 'https://en.wikipedia.org/wiki/Imam_Khomeini_Spaceport',
    },
    SUBL: {
        site: 'Submarine Launch Platform',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Submarine-launched_ballistic_missile',
    },
    KYMSC: {
        site: 'Kapustin Yar MSC',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Kapustin_Yar',
    },
    SRILR: {
        site: 'Satish Dhawan Space Centre',
        country: 'India',
        wikiUrl: 'https://en.wikipedia.org/wiki/Satish_Dhawan_Space_Centre',
    },
    SVOBO: {
        site: 'Svobodny Cosmodrome',
        country: 'Russia',
        wikiUrl: 'https://en.wikipedia.org/wiki/Svobodny_Cosmodrome',
    },
    TAISC: {
        site: 'Taiyuan SLC',
        country: 'China',
        wikiUrl: 'https://en.wikipedia.org/wiki/Taiyuan_Satellite_Launch_Center',
    },
    TANSC: {
        site: 'Tanegashima Space Center',
        country: 'Japan',
        wikiUrl: 'https://en.wikipedia.org/wiki/Tanegashima_Space_Center',
    },
};
